// Copyright 2015-2023 Nstream, inc.
// All rights reserved.

import {TimeSeriesController} from "@nstream/widget";

/** @public */
export class ValueDataController extends TimeSeriesController {
}
